import moment from 'moment';
export default {
  //可以传url和url数组
  download(arr: string | string[]) {
    const downloadUrl = (url: string) => {
      const iframe: any = document.createElement('iframe');
      iframe.style.display = 'none'; // 防止影响页面
      iframe.style.height = 0; // 防止影响页面
      iframe.src = url;
      document.body.appendChild(iframe); // iframe挂在到dom树上才会发请求
      // 5秒之后删除
      setTimeout(() => {
        iframe.remove();
      }, 5000);
    };

    if (typeof arr === 'string') {
      downloadUrl(arr);
    } else {
      arr.map((url) => {
        downloadUrl(url);
      });
    }
  },
  //获取url的参数
  // getQueryParams() {
  //   // console.log('document.location  ', document.location);
  //   let url: string = document.location.toString();
  //   // 如果url中有特殊字符则需要进行一下解码
  //   url = decodeURI(url);
  //   let arr1 = url.split('?');
  //   let obj = {};
  //   if (arr1.length > 1) {
  //     let arr2 = arr1[1].split('&');
  //     for (let i = 0; i < arr2.length; i++) {
  //       let curArr = arr2[i].split('=');
  //       obj[curArr[0]] = decodeURIComponent(curArr[1]);
  //     }
  //   }
  //   return obj;
  // },
  //生成guid
  newGuid() {
    const S4 = () => {
      return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    };

    return (
      S4() +
      S4() +
      '-' +
      S4() +
      '-' +
      S4() +
      '-' +
      S4() +
      '-' +
      S4() +
      S4() +
      S4()
    );
  },
  //保留小数位
  decimalFormat(num: string | number | undefined | null, decimal = 2) {
    // return Math.round(Number(num) * 10 ** decimal) / 10 ** decimal;
    let num2 = Number(num || 0).toFixed(decimal);

    if (Number(num2) === 0) {
      num2 = (num2 || '').replace(/^([-+])(.*)/, '$2');
    }
    return num2;
  },
  //千分位格式化
  thousandthFormat(num: string | number | undefined | null, decimal = 2) {
    return this.decimalFormat(num, decimal)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  },
  // 格式化时间
  filterDate(text: any, formate = 'YYYY-MM-DD', unit = '-') {
    if (!text) return unit;
    return moment(text).format(formate);
  },
  /**
 * 检查参数是否为undefined 或者 null
 * @param val
 * @returns {boolean}
 */
  isUndefined(val: any) {
    if (val === undefined) return true;
    if (val == null) return true;
    return false;
  },
  /**
  * 检查字符串是否为undefined 或 长度为 0
  * @param val
  * @returns {boolean}
  */
  isEmptyString(val: any) {
    if (this.isUndefined(val)) return true;
    return (val.length == 0);
  },
  // 格式化数字文本显示，没值的时候显示-
  filterNumber(val: any) {
    if (this.isEmptyString(val)) return '-';
    return val;
  },
  // 处理乘法小数点精度问题
  $multiply(number: any, mult: any) {
    return (
      (parseFloat(number || 0) * 1000 * (parseFloat(mult || 0) * 1000)) /
      1000000
    );
  },
  // 处理加法小数点精度问题
  $accAdd(number: any, add: any) {
    return (
      (parseFloat(number || 0) * 1000 + parseFloat(add || 0) * 1000) / 1000
    );
  },
  // 处理减法小数点精度问题
  $accSub(number: any, sub: any) {
    return (
      (parseFloat(number || 0) * 1000 - parseFloat(sub || 0) * 1000) / 1000
    );
  },
  // 除法
  $division(arg1: any, arg2: any): number {
    // 除法 arg1 ➗ arg2
    if (arg2 === 0) return 0;
    return (parseFloat(arg1 || 0) * 1000) / (parseFloat(arg2 || 0) * 1000);
  },
};
